import React, { useState } from "react";
import { Button, Select, Typography, Row, Col, Slider, Progress, Card } from "antd";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import './index.scss';

const { Title, Text } = Typography;
const { Option } = Select;

const AverageBasePay: React.FC = () => {
    const [filters, setFilters] = useState({
        location: "All",
        department: "All",
        jobTitle: "All",
    });

    const [experience] = useState({ min: 0, max: 4.69 });
    const [salary] = useState({ min: 0, max: 9.6 });
    const [avgExperience] = useState(0);
    const [avgSalary] = useState(0);

    const pieData = [
        { name: "Fix Pay", value: 90, color: "#00C49F" },
        { name: "Contribution", value: 5, color: "#8884D8" },
        { name: "Bonus", value: 3, color: "#FF69B4" },
        { name: "Other", value: 2, color: "#FFBB28" },
    ];

    const handleChange = (name: string, value: string) => {
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleRun = () => {
        console.log("Filters applied: ", filters);
    };

    return (
        <>
            <Row gutter={16}>
                <Col span={12}>
                    <Row style={{ marginTop: "20px" }} gutter={[16, 40]}>
                        <Col span={12}>
                            <>
                                <Title level={5}>Experience</Title>
                                <Slider
                                    range
                                    defaultValue={[experience.min, experience.max]}
                                    min={0}
                                    max={5}
                                />
                                <Text>{`${experience.min} Yrs - ${experience.max} Yrs`}</Text>
                            </>
                        </Col>
                        <Col span={12}>
                            <Title level={5}>Annual Salary Range</Title>
                            <Slider
                                range
                                defaultValue={[salary.min, salary.max]}
                                min={0}
                                max={5}
                                dots
                            />
                            <Text>{`INR ${salary.min}L - INR ${salary.max}L`}</Text>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Title level={5}>Average Experience</Title>
                                <div className="tag_name_chart">
                                    0 Years
                                </div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Title level={5}>Average Salary</Title>
                                <div className="tag_name_chart">
                                    0 LPA
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row style={{ marginTop: "20px" }}>
                        <Col span={24}>
                            <ResponsiveContainer width="100%" height={300}>
                                <PieChart>
                                    <Pie
                                        data={pieData}
                                        dataKey="value"
                                        outerRadius={100}
                                        label={({ name, percent }) =>
                                            `${name} ${(percent * 100).toFixed(0)}%`
                                        }
                                    >
                                        {pieData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend />
                                </PieChart>
                            </ResponsiveContainer>
                        </Col>
                    </Row>
                </Col>
            </Row >
        </>
    );
};

export default AverageBasePay;
